import { UseMutateAsyncFunction } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { Response } from "../services/api";
import { useDeleteDisClosure } from "../components/app/DeleteModal";
import { getXtenantId } from "../utils/utils";

export type ArchiveMutation = {
  id: string;
  status: boolean;
  xTENANTID?: string;
};

/**
 * @param mutation - The mutation function to use for archiving
 *
 * @example
 *
 * const { mutateAsync: archiveMutation } = useArchiveAppointment();
 * const { archiveHandler, deleteDisc } = useArchiveState(archiveMutation);
 *
 * archiveHandler(true, "123");
 *
 * @returns An object containing the delete disclosure
 * @returns The archive handler function
 *
 * @author [Rajkumar Rathod]
 */
export const useArchiveState = (
  mutation: UseMutateAsyncFunction<
    AxiosResponse<Response, any>,
    unknown,
    ArchiveMutation,
    unknown
  >
) => {
  const deleteDisc = useDeleteDisClosure();

  const archiveHandler = async (
    value: boolean,
    id?: string,
    xTENANTID?: string
  ) => {
    return mutation({
      id: id ?? "",
      status: value,
      xTENANTID: xTENANTID ?? getXtenantId(),
    });
  };

  return {
    deleteDisc,
    archiveHandler,
  };
};
